module.exports = __webpack_public_path__ + "images/emoji/leopard.90b93e06ce00982a7947.png";